define([
    'jquery',
    'globalVars',
], ($, { $body, $html }) => {
    return {
        settings: {
            $menuIcon: $('#menuToggle'),
            $navigation: $('.nav-sections'),

            navigationItem: '.js-menu-nav-item',
            navigationCategoryItem: '.js-menu-nav-category-item',
            navItemLink: '.js-menu-nav-link',
            categoryLink: '.js-menu-nav-category-link',
            categoriesList: '.js-menu-nav-categories-list',
            navigationLink: '.js-menu-nav-link',
            submenuBack: '.js-submenu-back',
            menuOverlay: '.js-menu-overlay',

            classMenuOpen: '_menu-open',
            classOpen: '_open',
            classSubmenu: '_submenu',
            classActive: '_active',
            classCategoryLink: '_category-link',

            classItemLevel0: 'level0',
            classItemLevel1: 'level1',
            classItemLevel2: 'level2',
            classItemLevel3: 'level3',

            $activeTitle: null,
            $activeItem: null,
        },

        init() {
            this.bindEvents();
        },

        bindEvents() {
            this.settings.$menuIcon.on('click', this.toggleMenu.bind(this));

            $body.on('click', this.settings.submenuBack, this.closeSubmenu.bind(this));
            $body.on('click', this.settings.navigationLink, this.clickMenuLink.bind(this));
            $body.on('click', this.settings.categoryLink, this.clickMenuLink.bind(this));
            $body.on('tap', this.settings.menuOverlay, this._closeMenu.bind(this));
        },

        toggleMenu(ev) {
            ev.preventDefault();

            $html.hasClass(this.settings.classMenuOpen) ? this._closeMenu() : this._openMenu();
        },

        _openMenu() {
            $html.addClass(this.settings.classMenuOpen);
        },

        _closeMenu(ev) {
            ev && ev.preventDefault();

            $html.removeClass(this.settings.classMenuOpen);
        },

        clickMenuLink(ev) {
            const $this = $(ev.currentTarget);

            if ($this.hasClass(this.settings.classActive)) return;

            ev.preventDefault();

            this.openSubmenu(ev, $this);
        },

        getCategoryItemByLink(link) {
            return link.closest(`${this.settings.navigationCategoryItem}`);
        },

        hideCategoryItem(excluded) {
            $(this.settings.navigationCategoryItem).each((i, el) => {
                if ($(el).data('identity') !== $(excluded).data('identity')) $(el).hide();
            });
        },

        showCategoriesList(el, level) {
            el.find(`${this.settings.categoriesList}`).show()
                .find(`.${level}`).each((i, el) => { $(el).css('margin-bottom', '22px').show(); });
        },

        openSubmenu(ev, $this) {
            ev.preventDefault();

            let $parent = $this.closest(this.settings.navigationItem);

            if ($this.hasClass(this.settings.classCategoryLink)) {
                $parent = this.getCategoryItemByLink($this);
            }

            if ($parent.hasClass(this.settings.classItemLevel1)) {
                this.hideCategoryItem($parent);

                $(`${this.settings.navigationLink}.${this.settings.classActive}`).hide();

                this.showCategoriesList($parent, this.settings.classItemLevel2);
            } else if ($parent.hasClass(this.settings.classItemLevel2)) {
                this.hideCategoryItem($parent);

                $(`${this.settings.categoryLink}.${this.settings.classActive}`).hide();
                $(`${this.settings.navigationCategoryItem}.${this.settings.classOpen}`).show();

                this.showCategoriesList($parent, this.settings.classItemLevel3);
            }

            this.settings.$navigation.addClass(this.settings.classSubmenu);

            this.settings.$activeTitle = $this.addClass(this.settings.classActive);
            this.settings.$activeItem = $parent.addClass(this.settings.classOpen);
        },

        closeSubmenu(ev) {
            ev.preventDefault();

            let $title = this.settings.$activeTitle;
            let $active = this.settings.$activeItem;

            this.settings.$activeTitle.removeClass(this.settings.classActive);
            this.settings.$activeItem.removeClass(this.settings.classOpen);

            if ($active.hasClass(this.settings.classItemLevel1)) {
                $active = $active.closest(this.settings.navigationItem);
                $title = $active.find(this.settings.navigationLink);

                $active.find(this.settings.navigationCategoryItem).each((i, el) => {
                    $(el).show().find(this.settings.categoriesList).each((i, el) => { $(el).hide(); });
                });
            } else if ($active.hasClass(this.settings.classItemLevel2)) {
                $active = $active.closest(`${this.settings.navigationCategoryItem}.${this.settings.classItemLevel1}`);
                $title = $active.find(this.settings.categoryLink);

                $active.find(this.settings.navigationCategoryItem).each((i, el) => {
                    $(el).show().css('margin-bottom', 0)
                        .find(this.settings.categoriesList).each((i, el) => { $(el).hide(); });
                });
            }

            if (this.settings.$activeItem.hasClass(this.settings.classItemLevel0)) {
                this.settings.$navigation.removeClass(this.settings.classSubmenu);
            }

            this.settings.$activeTitle = $title.show();
            this.settings.$activeItem = $active;
        },
    };
});
